<template>
  
  <div>

    <div class="ui segment">
      <div class="ui form">
        <div class="fields">
          <div class="three wide field">
            <label class="form-label">Data Inicial <span class="red text">*</span></label>
            <date-picker @onChange="onChangeStartDate"/>
          </div>
          <div class="three wide field">
            <label class="form-label">Data Final <span class="red text">*</span></label>
            <date-picker @onChange="onChangeEndDate"/>
          </div>    
          <div class="four wide field">
            <label class="form-label">Período de Pagamento <span class="red text">*</span></label>
            <select-dropdown ref="paymentPeriodDropdown" @onChange="onChangePaymentPeriod" />
          </div>      
          <div class="six wide field">
            <label class="form-label">Cliente</label>
            <customer-picker ref="customerPicker" @onClear="onClearCustomer" @onPick="onPickCustomer" />
          </div>
        </div>
      </div>
    </div>

    <button class="ui right floated blue button" :class="{ disabled: !enableForwardButton }" 
      @click="$emit('onForward', filter)">
      Avançar <i class="arrow right icon"></i> 
    </button>

  </div>

</template>

<script>

  import FinancialService from "@/services/financial-service"
  import { DatePicker, SelectDropdown, CustomerPicker } from "@/components"

  export default {

    name: "FilterStep",

    data() {
      return {
        filter: {
          startDate: null,
          endDate: null,
          paymentPeriod: "*",
        },
      }
    },
    
    components: {
      DatePicker,
      SelectDropdown,
      CustomerPicker,
    },

    mounted() {
      this.initPaymentPeriodDropdown()      
    },

    computed: {

      enableForwardButton() {
        return (this.filter.startDate && this.filter.endDate && this.filter.paymentPeriod)
      },
    },

    methods: {

      initPaymentPeriodDropdown() {

        let values = [{ id: "*", label: "Todos" }]
        let periods = FinancialService.getPaymentPeriodList()

        periods.forEach((period) => values.push(period))

        this.$refs.paymentPeriodDropdown.setValues(values, this.filter.paymentPeriod)
      },

      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()
      },

      onChangePaymentPeriod(paymentPeriod) {        
        this.filter.paymentPeriod = paymentPeriod        
        this.refreshData()
      },

      onPickCustomer(customer) {
        this.filter.customer = customer
        this.refreshData()
      },

      onClearCustomer() {
        this.filter.customer = null
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },      
    },
  }

</script>


